import {css} from 'lit';
export const styles = css`:host {
  line-height: 1;
}

.trigger {
  position: relative;
  padding: 0;
  border: 1px solid transparent;
  background-color: transparent;
  color: var(--text-primary);
  z-index: 1;
}

.trigger::before {
    content: '';
    position: absolute;
    top: -4px;
    right: -8px;
    bottom: -4px;
    left: -8px;
    border-radius: 16px;
    background-color: transparent;
    z-index: -1;
  }

.trigger.active {
    --icon-color-primary: var(--color6);
  }

.trigger[aria-expanded='true'] {
    --text-primary: var(--color6);
  }

.trigger.focus-visible {
    outline-offset: 4px;
  }

.trigger:focus-visible {
    outline-offset: 4px;
  }

@media (hover: hover) {
    .trigger:hover {
      --text-primary: var(--color6);
    }
  }

.trigger:active::before {
      background-color: var(--gray-200);
    }

.bu-btn {
  font-size: 14px;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  display: block;
}

.btn-naked-dark {
  display: flex;
}

.btn-naked-dark span {
    overflow: hidden;
    text-overflow: ellipsis;
  }

.btn-naked-dark.attend bu-icon {
      color: var(--success);
    }

.btn-naked-dark.not-attend bu-icon {
      color: var(--danger);
    }
`;
export default styles;
